<template>
  <p class="sign-text"><slot /></p>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.sign-text {
  font-size: 14px;
  line-height: 125%;
  text-align: center;
  margin-bottom: 32px;
  color: var(--color-dark-grey);
  @include point-md {
    margin-bottom: 24px;
  }
  @include point-lg {
    font-size: 16px;
    margin-bottom: 32px;
  }
}
</style>
